import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { toast } from 'sonner'

import { useAuth } from '@/lib/auth'
import { hasRole } from '@/lib/hasRole'
import { Role } from '@/types/User'

export const useSubscriptionGuard = (redirectTo: string) => {
  const { user, isLoading } = useAuth({
    middleware: 'auth',
    redirectTo: '/auth/login',
    tmp: 'useSubscriptionGuard',
  })
  const navigate = useNavigate()
  const { t } = useTranslation(undefined, {
    keyPrefix: 'subscription.banner',
  })

  useEffect(() => {
    if (isLoading || !user) {
      return
    }

    if (hasRole(user.roles, Role.admin)) {
      return
    }

    if (user.sia) {
      return
    }

    toast.error(t('blockedToast'), { id: 'subscription-inactive' })
    navigate(redirectTo, { replace: true })
  }, [user, isLoading, navigate, redirectTo, t])

  const isAllowed =
    isLoading || !user || user.sia || hasRole(user.roles, Role.admin)

  return { isAllowed, isLoading }
}
